module.exports = __webpack_public_path__ + "static/media/fleetprocure--background.dbc0e6b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/fleetprocure/fleetprocure--background.jpg
// module id = 164
// module chunks = 0